/**
 * street-drama-cues.js
 * Danh sách phụ đề, người nói và kịch bản thoại chi tiết cho hoạt cảnh "Tranh Khách Vỉa Hè" 62 giây.
 */

export const STREET_DRAMA_CUES = [
  {
    id: 's1_xanh',
    characterId: 'TAI_XE_XANH_SM',
    speaker: 'Bác Tài Xanh SM',
    text: 'Bác Ba ơi! Đi Xanh SM đi bác! Xe điện VinFast êm ru mát rượi nè!',
    scene: 0
  },
  {
    id: 's1_grab',
    characterId: 'TAI_XE_GRAB',
    speaker: 'Tài xế Grab',
    text: 'Khoan đã Bác Ba! Đi Grab xe ôm bao rẻ, chạy nhanh lẹ nè bác ơi!',
    scene: 0
  },
  {
    id: 's2_xanh',
    characterId: 'TAI_XE_XANH_SM',
    speaker: 'Bác Tài Xanh SM',
    text: 'Ủa em trai, tôi tới trước rước khách mà, sao chen ngang vậy?!',
    scene: 1
  },
  {
    id: 's2_grab',
    characterId: 'TAI_XE_GRAB',
    speaker: 'Tài xế Grab',
    text: 'Khách chưa lên xe thì ai nhanh người ấy bắt! Mày ý kiến gì?!',
    scene: 1
  },
  {
    id: 's2_ba',
    characterId: 'BAC_BA_BA',
    speaker: 'Bác Ba Nam Bộ',
    text: 'Thôi thôi hai chú ơi! Đầu đường xó chợ đừng cãi lộn mất hòa khí!',
    scene: 1
  },
  {
    id: 's3_trada',
    characterId: 'NGUOI_BAN_TRA_DA',
    speaker: 'Bác Bán Trà Đá',
    text: 'Hai cậu kia dừng tay lại! Vào làm cốc trà đá cho hạ hỏa nào!',
    scene: 2
  },
  {
    id: 's3_grab',
    characterId: 'TAI_XE_GRAB',
    speaker: 'Tài xế Grab',
    text: 'Lão già nhiều chuyện! Biến ngay không tao đấm vỡ mặt bây giờ?!',
    scene: 2
  },
  { id: 's4_grab_attack', characterId: 'TAI_XE_GRAB', speaker: 'Tài xế Grab', text: 'Ăn đấm này lão già!', scene: 3 },
  {
    id: 's4_grab_miss',
    characterId: 'TAI_XE_GRAB',
    speaker: 'Tài xế Grab',
    text: 'Hụt rồi?! Sao né nhanh thế?!',
    scene: 3
  },
  {
    id: 's4_trada',
    characterId: 'NGUOI_BAN_TRA_DA',
    speaker: 'Bác Bán Trà Đá',
    text: 'Mày dám manh động với người già à?!',
    scene: 3
  },
  {
    id: 's4_grab_dizzy',
    characterId: 'TAI_XE_GRAB',
    speaker: 'Tài xế Grab',
    text: 'Ối giời ôi... sao đấm đau thế... hoa hết cả mắt...',
    scene: 3
  },
  {
    id: 's5_grab_stumble',
    characterId: 'TAI_XE_GRAB',
    speaker: 'Tài xế Grab',
    text: 'Không xong rồi... ngã đây...',
    scene: 4
  },
  {
    id: 's5_trada',
    characterId: 'NGUOI_BAN_TRA_DA',
    speaker: 'Bác Bán Trà Đá',
    text: 'Tôi năm nay 70 tuổi chưa gặp trường hợp này bao giờ!',
    scene: 4
  },
  {
    id: 's5_xanh',
    characterId: 'TAI_XE_XANH_SM',
    speaker: 'Bác Tài Xanh SM',
    text: 'Dạ thôi bác Ba, để con chở bác đi xe điện cho an toàn lành lặn!',
    scene: 4
  }
];
